"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.common = exports.warning = exports.secondary = exports.primary = void 0;
exports.primary = {
    500: '#c9fb00',
    600: '#018436',
};
exports.secondary = {
    400: '#d6dcdc',
};
exports.warning = {
    main: '#FB6900',
    dark: '#E86101',
    light: '#FC7F25',
};
exports.common = {
    white: '#fff',
    black: '#07070c',
};
//# sourceMappingURL=project-citrus.js.map